import { useState, useEffect } from "react";
import { API_URL } from "../config";

/**
 * Lee la imagen de publicidad del carrito guardada en la configuración.
 * @returns {{ publicidad: string|null, loading: boolean }}
 */
const usePublicidadCarrito = () => {
  const [publicidad, setPublicidad] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();

    fetch(`${API_URL}/api/configuracion/publicidad-carrito`, {
      credentials: "include",
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch cart advertising");
        return res.json();
      })
      .then((data) => {
        if (!controller.signal.aborted && typeof data?.publicidadCarrito === "string") {
          setPublicidad(data.publicidadCarrito);
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") {
          console.error("usePublicidadCarrito: no se pudo cargar la publicidad", err);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });

    return () => controller.abort();
  }, []);

  return { publicidad, loading };
};

export default usePublicidadCarrito;
